<template>
  <div class="home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->



    <el-tabs v-model="activeName" class="demo-tabs"
     @tab-click="handleClick">
      <el-tab-pane label="生成总汇文件" name="生成总汇文件">
        <uploadfile></uploadfile>
      </el-tab-pane>
      <el-tab-pane label="上传文件到数据库" name="上传文件到数据库">
        <uploadxls2></uploadxls2>
      </el-tab-pane>
  
      <el-tab-pane label="打印文件" name="打印文件">
        <printfiles></printfiles>
      </el-tab-pane>
      <el-tab-pane label="树状图" name="树状图">
        <TreeGoods></TreeGoods>
      </el-tab-pane>
      <el-tab-pane label="合同管理" name="合同管理">
        <TenderEntity></TenderEntity>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import printfiles from '@/components/printfiles.vue';
import TenderEntity from '@/components/TenderEntity.vue';
import TreeGoods from '@/components/TreeGoods2.vue';
import uploadfile from '@/components/uploadfile.vue';
import uploadxls from '@/components/uploadxls.vue';
import uploadxls2 from '@/components/uploadxls2.vue';

export default {
  name: 'HomeView',
  components: {
    //  ShareImgcuting,
    uploadfile,
    uploadxls,
    printfiles,
    TenderEntity,
    uploadxls2,
    TreeGoods
  },
  data() {
    return {
      activeName: '生成总汇文件'
    };
  },
  mounted() {
    // 设置初始页面标题
    this.updatePageTitle(this.activeName);
  },
  watch: {
    activeName(newVal) {
      // 当 activeName 改变时更新页面标题
      this.updatePageTitle(newVal);
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      this.activeName = tab.name;
    },
    updatePageTitle(tabName) {
      // 根据标签名称更新浏览器标签页标题
      document.title = tabName || '货物tree估算模型';
    },
    goToUpload() {
      // 使用 router 中实际注册的路由名 uploadFileView
      this.$router.push({ name: 'uploadFileView' });
    }
  }
};
</script>
